import { Box, type BoxProps } from '@mui/material';
import { type ReactNode, useEffect, useState } from 'react';
import { useParticipantLogoUrl } from '../../hooks/useParticipantLogoUrl';
import { mergeSx } from '../../utils/styles';
import { CompetitionFlag } from './CompetitionFlag';

type ParticipantLogoProps = {
  competitionName?: string | null;
  participantId?: string | null;
  participantName?: string | null;
  size?: number | string;
  sx?: BoxProps['sx'];
  fallback?: ReactNode;
};

const ParticipantLogo = ({
  competitionName,
  participantId,
  participantName,
  size = 20,
  sx,
  fallback,
}: ParticipantLogoProps) => {
  const [failed, setFailed] = useState(false);
  const logoUrl = useParticipantLogoUrl(participantId);

  useEffect(() => {
    setFailed(false);
  }, [logoUrl]);

  if (!logoUrl) {
    return fallback ?? null;
  }

  if (failed) {
    if (competitionName) {
      return <CompetitionFlag name={competitionName} width={size} height={size} sx={sx} />;
    }

    return fallback ?? null;
  }

  return (
    <Box
      component='img'
      src={logoUrl}
      alt={participantName ? `${participantName} logo` : ''}
      loading='lazy'
      sx={mergeSx(
        {
          width: size,
          height: size,
          flexShrink: 0,
          objectFit: 'contain',
          display: 'block',
        },
        sx
      )}
      onError={() => setFailed(true)}
    />
  );
};

export default ParticipantLogo;
